import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

import { guideSectionForPath, illustratedGuideUrl } from "../content/adminGuide";

/** Botón "?" contextual (Eduardo 2026-08-23): abre la ficha de la guía de
 * la sección donde está parado el admin — la instrucción llega en la
 * pantalla donde se necesita, no en un documento aparte. */
export default function GuideHelpButton() {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const section = guideSectionForPath(location.pathname);
  if (!section) return null;

  const tournamentMatch = location.pathname.match(/^\/admin\/tournaments\/(\d+)/);
  const guideHref = `/admin/guia?seccion=${section.key}${tournamentMatch ? `&tournament=${tournamentMatch[1]}` : ""}`;

  return (
    <>
      <button
        type="button"
        className="guide-help-button"
        aria-label={`Ayuda de ${section.title}`}
        title={`¿Cómo funciona ${section.title}?`}
        onClick={() => setOpen(true)}
      >
        ?
      </button>
      {open && (
        <div className="guide-help-overlay" role="dialog" aria-modal="true" aria-label={`Guía de ${section.title}`}>
          <div className="guide-help-card card">
            <div className="card__header-row">
              <div>
                <p className="eyebrow">Guía rápida · paso {section.order}</p>
                <h2 className="card__title">{section.icon} {section.title}</h2>
                <p className="card__subtitle">{section.purpose}</p>
              </div>
              <button type="button" className="btn btn--ghost btn--compact" onClick={() => setOpen(false)} aria-label="Cerrar ayuda">
                ✕
              </button>
            </div>
            <h3>Qué haces aquí</h3>
            <ol>
              {section.steps.map((step) => (
                <li key={step}>{step}</li>
              ))}
            </ol>
            {section.warnings.length > 0 && (
              <ul className="guide-warnings">
                {section.warnings.map((warning) => (
                  <li key={warning}>⚠️ {warning}</li>
                ))}
              </ul>
            )}
            <p className="guide-done">✅ <strong>Listo cuando…</strong> {section.doneWhen}</p>
            <div className="form__actions">
              <Link className="btn btn--ghost" to={guideHref} onClick={() => setOpen(false)}>
                Ver guía completa
              </Link>
              <a
                className="btn btn--ghost"
                href={illustratedGuideUrl(section)}
                target="_blank"
                rel="noreferrer"
                onClick={() => setOpen(false)}
              >
                📸 Con capturas paso a paso
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
